import { Component, OnInit } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { CategoryService } from 'src/app/shared/category-list/category.service';
import { SubCategoryModel } from 'src/app/shared/category-list/models/subcategory';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public subCategories: SubCategoryModel[] = [];
  public Menus: any[] = [];
  public categories: any[] = [];
  
  private menuTimeout: any;
  // المتغير الجديد لتتبع القائمة النشطة
  private activeTrigger: MatMenuTrigger | null = null; 

  constructor(private categoryService: CategoryService, private router: Router) {}

  ngOnInit() {
    this.categoryService.GetMenu().subscribe(res => this.Menus = res);
    this.categoryService.getAllSubCategorys().subscribe(data => {
      this.subCategories = data;
      this.showGroup();
    });
  }

  // --- دوال التحكم في الماوس (محدثة) ---
  public onMenuEnter(trigger: MatMenuTrigger) {
    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
    }

    // السر هنا: إذا كانت هناك قائمة أخرى مفتوحة، قم بإغلاقها فوراً
    if (this.activeTrigger && this.activeTrigger !== trigger) {
      this.activeTrigger.closeMenu();
    }

    // تعيين القائمة الحالية كـ "قائمة نشطة" وفتحها
    this.activeTrigger = trigger;
    if (!trigger.menuOpen) {
      trigger.openMenu();
    }
  }

  public onMenuLeave(trigger: MatMenuTrigger) {
    this.menuTimeout = setTimeout(() => {
      if (trigger.menuOpen) {
        trigger.closeMenu();
      }
      // تصفير القائمة النشطة بعد إغلاقها
      if (this.activeTrigger === trigger) {
        this.activeTrigger = null;
      }
    }, 100); // 100ms تعطي استجابة أسرع عند التنقل بين الأزرار
  }

  public onMegaMenuEnter() {
    // إبقاء القائمة مفتوحة عند دخول الماوس داخل البطاقة
    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
    }
  }
  // ----------------------------------------

  public showGroup() {
    const group = this.subCategories.reduce((acc: any, curr) => {
      let key = curr.categoryName;
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    }, {});
    
    this.categories = Object.keys(group).map(key => ({
      category: key,
      subCategories: this.showSubGroup(group[key]) 
    }));
    this.categories.forEach(el => { if (el.subCategories.length > 0) el.subCategories.splice(0, 1); });
  }

  public showSubGroup(subCategories: any[]) {
    const group = subCategories.reduce((acc: any, curr) => {
      let key = curr.parentNameAr;
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    }, {});
    return Object.keys(group).map(key => ({ category: key, subCategories: group[key] }));
  }

  public checkLength(item: any) {
    return !(item && item.subCategory && item.subCategory.length > 4);
  }
}